import React from 'react'
import PropTypes from 'prop-types'
import AsyncCreatable from 'react-select/async-creatable'
import { components } from 'react-select'

const Dropdown = ({
  options,
  input,
  meta,
  disabled,
  groupClassName,
  label,
  labelClassName,
  // selectClassName,
  errorClassName,
  // inputErrorClassName,
  onClick,
  placeholder,
  loadOptions,
  selectStyles,
  inputClassName,
  limit,
  limitLabel,
}) => {
  // const classNameSelect = `form-control w-full ${
  //   meta.touched && meta.error ? [selectClassName, inputErrorClassName].join(' ') : selectClassName
  // }`
  const Menu = (menuProps) => {
    const valueLength = menuProps.getValue().length || 0
    return (
      <components.Menu {...menuProps}>
        {(!limit || (limit && valueLength < limit)) && menuProps.children}
        {limit <= valueLength && <div className="m-3 text-center text-sm italic">{limitLabel}</div>}
      </components.Menu>
    )
  }

  return (
    <div className={`form-group ${groupClassName}`}>
      {label && <label className={labelClassName}>{label}</label>}
      <div className={`form-control w-full`}>
        <AsyncCreatable
          styles={selectStyles}
          classNamePrefix="react-select"
          isMulti
          {...input}
          defaultOptions={options}
          loadOptions={loadOptions}
          components={{ Menu }}
          className={`${inputClassName}`}
          onBlur={() => input.onBlur(input.value)}
          onClick={onClick}
          disabled={disabled}
          placeholder={placeholder}
        />
      </div>
      {meta.touched && meta.error && <p className={`form-error ${errorClassName}`}>{meta.error}</p>}
    </div>
  )
}

Dropdown.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  label: PropTypes.string,
  selectClassName: PropTypes.string,
  groupClassName: PropTypes.string,
  errorClassName: PropTypes.string,
  inputErrorClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  options: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  value: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  selectStyles: PropTypes.object,
  inputClassName: PropTypes.string,
  limit: PropTypes.number,
  limitLabel: PropTypes.string,
  loadOptions: PropTypes.func,
}

Dropdown.defaultProps = {
  selectStyles: {
    control: (styles, { selectProps }) => ({
      ...styles,
      backgroundColor: '#edf2f7',
      borderRadius: selectProps.menuIsOpen ? '4px 4px 0 0' : '4px',
      border: 'none',
      boxShadow: 'none',
      '&:hover': {
        border: 'none',
      },
    }),
    dropdownIndicator: (styles, { selectProps }) => ({
      ...styles,
      transform: selectProps.menuIsOpen ? 'scaleY(-1)' : null,
    }),
    indicatorSeparator: (styles) => ({ ...styles, display: 'none' }),
  },
}

export default Dropdown
